<div class="maindiv"
  fxLayout="column"
  fxLayoutGap="10px">

  <div fxLayout="row"
    fxLayoutAlign=" center"
    fxLayoutGap="10px">
    <user-image [profile]="user"></user-image>
    <div>{{ user?.use_nickname ? user?.private_nickname : user?.firstname+" "+user?.lastname }}</div>
  </div>

  <div *ngFor="let item of navpoints"
    class="entry"
    [routerLink]="item.action?null:item.target"
    routerLinkActive="selected"
    (click)="click(item)"
    fxLayout="row"
    fxLayoutGap="">

    <!-- icon -->
    <div style="min-width: 40px; text-align: center;">
      <i *ngIf="item.icon_type == 'FA'"
        [ngClass]="item.icon"></i>
      <img *ngIf="item.icon_type == 'IMG'"
        style="height: 20px;"
        [src]="item.icon" />
    </div>

    <!-- text -->
    <div class="text">{{ item.caption }}</div>
  </div>

</div>
